<div class="m-pagination"
     :class="{'m--is-loading': loading}">
    <div class="m-pagination__status"
         ref="status">{{ status }}</div>
    <div v-if="pagesTotal > 1"
         class="m-pagination__indicator"></div>
    <div v-if="pagesTotal > 1"
         class="m-pagination__nav"
         ref="navigation">
        <m-icon-button class="m-pagination__previous-button"
                       ref="previous"
                       :disabled="firstPageSelected || loading"
                       icon-name="m-svg__chevron-circle--left"
                       :title="$i18n.translate('m-pagination:previous')"
                       skin="link"
                       @click="goToPage(value - 1)">
            {{ $i18n.translate('m-pagination:previous') }}
        </m-icon-button>
        <ul class="m-pagination__pages">
            <li v-for="(item, index) of paginationItems"
                class="m-pagination__item"
                :class="{'m-pagination__item--ellipsis': item.ellipsis, 'm--is-active': isPageActive(parseInt(item.label))}"
                :key="index">
                <m-link v-if="item.clickable"
                        class="m-pagination__item--link"
                        :disabled="loading"
                        mode="button"
                        @click="goToPage(parseInt(item.label))">{{ item.label }}</m-link>
                <span v-else
                      class="m-pagination__item--text">{{ item.label }}</span>
            </li>
        </ul>
        <m-icon-button class="m-pagination__next-button"
                       ref="next"
                       :disabled="lastPageSelected || loading"
                       icon-name="m-svg__chevron-circle--right"
                       :title="$i18n.translate('m-pagination:next')"
                       skin="link"
                       @click="goToPage(value + 1)">
            {{ $i18n.translate('m-pagination:next') }}
        </m-icon-button>
    </div>
</div>
